import { render, staticRenderFns } from "./PanelOnClick.vue?vue&type=template&id=5a5e2a52&scoped=true"
import script from "./PanelOnClick.vue?vue&type=script&lang=js"
export * from "./PanelOnClick.vue?vue&type=script&lang=js"
import style0 from "./PanelOnClick.vue?vue&type=style&index=0&id=5a5e2a52&prod&scoped=true&lang=css"
import style1 from "./PanelOnClick.vue?vue&type=style&index=1&id=5a5e2a52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5e2a52",
  null
  
)

export default component.exports